import { useDispatch } from 'react-redux';

import { setCurrentContact } from 'app/features/chat/nfChatSlice';
import { useGetContactsQuery } from 'app/features/chat/chatApi';

const useChatFunctions = () => {
  const dispatch = useDispatch();
  const { data: contactsData } = useGetContactsQuery();

  const setCurrentContactBySlug = (slug) => {
    let contact = contactsData.contacts.find((contact) => {
      return contact.other_user.slug === slug;
    });

    if (contact) {
      window.history.pushState({}, '', `/chat/${contact.other_user.slug}`);
      dispatch(setCurrentContact({ contact }));
    } else {
      [contact] = contactsData.contacts;
      window.history.pushState({}, '', `/chat/${contact.other_user.slug}`);
      dispatch(setCurrentContact({ contact }));
    }
  };

  return { setCurrentContactBySlug };
};

export default useChatFunctions;
